import { message } from 'ant-design-vue'

import api from '@/api/auth'
import { setToken, removeToken } from '@/utils/auth'
import analytics from '@/utils/analytics'
import monitor from '@/utils/monitor'
import GLOBAL_ERROR_MSG from '@/config/errorMsg'

const auth = {
  namespaced: true,
  state: {
    id: -1,
    name: '',
    email: '',
    mobile: '',
    groups: null,
    volume: null
  },

  getters: {
    hasUserInfo: state => state.id !== -1,
    username: state => state.name || state.mobile || state.email,
    userId: state => state.id
  },

  mutations: {
    SET_TOKEN: (state, { token, isKeepLogin }) => {
      setToken(token, isKeepLogin)
    },
    SET_USERINFO: (state, userInfo) => {
      Object.assign(state, userInfo)

      monitor.setUser(userInfo)
      analytics.setUserId(userInfo.mobile)
    },

    FE_LOGOUT(state) {
      const userInfo = {
        id: -1,
        name: '',
        email: '',
        mobile: '',
        groups: null,
        volume: null
      }
      Object.assign(state, userInfo)
      removeToken()

      monitor.setUser({})
      analytics.setUserId('')
    }
  },

  actions: {
    async login({ dispatch, commit }, { userInfo, isKeepLogin }) {
      let resData = await api.login(
        { ...userInfo, client_id: +process.env.VUE_APP_CLIENT_ID || undefined },
        { noErrMsg: true }
      )
      let defaultMsg = '登录失败'

      if (resData.code === 0) {
        const bearerStr = `Bearer ${resData.token}`
        commit('SET_TOKEN', { token: bearerStr, isKeepLogin })

        resData = await dispatch('getInfo', { config: { noErrMsg: true } })
        defaultMsg = '获取用户信息失败'
        if (resData.code === 0) {
          return resData
        }
      }

      return {
        code: -1,
        msg: GLOBAL_ERROR_MSG[resData.code] || defaultMsg
      }
    },

    async getInfo({ commit }, { config = {} } = {}) {
      const resData = await api.getInfo({
        errMsg: '获取用户信息失败',
        ...config
      })
      const { user, code, groups, volume } = resData
      if (code === 0) {
        const userInfo = {
          id: user.id,
          name: user.name,
          email: user.email,
          mobile: user.mobile,
          groups,
          volume
        }

        commit('SET_USERINFO', userInfo)
      }

      return resData
    },

    async getCaptcha(context, { params }) {
      const resData = await api.getCaptcha(params, {
        errMsg: {
          2: '该用户不存在',
          default: '验证码发送失败，请重试或联系客服'
        }
      })

      if (resData.code === 0) {
        message.success('验证码已发送')
      }

      return resData
    }
  }
}

export default auth
